import { ShadowPicker } from "@/lib/components/ShadowPicker";
import { Switch } from "@/lib/components/Switch";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { ElementShadowDto, SceneTypeDto } from "@repo/api/overlays";

type Props = {
  element: {
    externalId: string;
    shadow: ElementShadowDto | null;
  };
  sceneType: SceneTypeDto;
};

export default function ElementShadowSection({ element }: Props) {
  const updateElement = useEditorStore((state) => state.service.updateElement);

  return (
    <>
      <div className="mt-8 mb-2 flex items-center gap-4">
        <div className="input-label m-0">Shadow</div>
        <Switch
          checked={element.shadow !== null}
          onCheckedChange={(newValue) => {
            updateElement(element.externalId, (element) => {
              if (!("shadow" in element)) {
                throw new Error("Shadow is not in element");
              }

              if (newValue) {
                element.shadow = {
                  color: {
                    type: "SOLID_COLOR",
                    format: "HEX",
                    color: "#000000",
                  },
                  opacity: 30,
                  x: 0,
                  y: 4,
                  blur: 8,
                };
              } else {
                element.shadow = null;
              }
            });
          }}
        />
      </div>
      {element.shadow !== null && (
        <ShadowPicker
          className="w-[296px]"
          value={{
            color: element.shadow.color.color,
            opacity:
              element.shadow.color.opacity ?? element.shadow.opacity ?? 100,
            x: element.shadow.x,
            y: element.shadow.y,
            blur: element.shadow.blur,
          }}
          onChange={(updates) => {
            updateElement(element.externalId, (element) => {
              if (!("shadow" in element)) {
                throw new Error("Shadow is not in element");
              }
              if (updates.color !== undefined) {
                element.shadow!.color.color = updates.color;
              }
              if (updates.opacity !== undefined) {
                element.shadow!.color.opacity = updates.opacity;
              }
              if (updates.x !== undefined) {
                element.shadow!.x = updates.x;
              }
              if (updates.y !== undefined) {
                element.shadow!.y = updates.y;
              }
              if (updates.blur !== undefined) {
                element.shadow!.blur = updates.blur;
              }
            });
          }}
        />
      )}
    </>
  );
}
